import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import {
  MatLegacyPaginator as MatPaginator,
  LegacyPageEvent as PageEvent,
} from '@angular/material/legacy-paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, map } from 'rxjs';

import { ProductSortimentPageResponse } from '@app/api/models';
import { MerchantActions } from '@merchant/store/merchant.slice';
import { TableDataSource } from '@shared/components/table/table-data-source.model';
import { paginatorConfiguration } from '@shared/constants/paginator-configuration';
import {
  ProductSortimentActions,
  ProductSortimentPageRequest,
  ProductSortimentSelectors,
} from '@sortiment/store/product-sortiment.slice';

import {
  VipDiscountsSellingActions,
  VipDiscountsSellingSelectors,
} from '../../store/vip-discounts-selling.slice';

@Component({
  selector: 'app-vip-discounts-products-and-partners',
  templateUrl: './vip-discounts-products-and-partners.component.html',
  styleUrls: ['./vip-discounts-products-and-partners.component.scss'],
})
export class VipDiscountsProductsAndPartnersComponent
  implements OnInit, AfterViewInit
{
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  public isLoading: Observable<boolean> = this.store.select(
    ProductSortimentSelectors.selectProductSortimentLoading
  );
  public productTableSource = new TableDataSource<
    ProductSortimentPageRequest,
    ProductSortimentPageResponse
  >(this.store);

  public totalProducts: Observable<number> = this.store.select(
    ProductSortimentSelectors.selectTotalProductSortiment
  );
  public pageSizeOptions = paginatorConfiguration.sortimentPageSizeOptions;
  public pageSize: number = this.pageSizeOptions[0];

  private pageEvent: PageEvent = <PageEvent>{
    pageSize: this.pageSize,
  };

  public get isProductSelected(): boolean {
    return this.productTableSource.selection.selected.length > 0;
  }

  isPartnerSelected$ = this.store
    .select(VipDiscountsSellingSelectors.selectPartners)
    .pipe(map((selection) => !!selection.length));

  filter: ProductSortimentPageRequest = {
    page: 0,
    size: this.pageSizeOptions[0],
  };

  constructor(
    private store: Store,
    private translateService: TranslateService,
    private router: Router
  ) {
    this.pageEvent.pageSize = this.pageSize;
  }

  ngOnInit(): void {
    this.getCellTooltip = this.getCellTooltip.bind(this);

    this.store.dispatch(MerchantActions.loadSites.trigger());
    this.store.dispatch(
      ProductSortimentActions.updateFilter.trigger({ filter: { priced: true } })
    );
  }

  ngAfterViewInit(): void {
    this.productTableSource.init(
      this.paginator,
      this.sort,
      undefined,
      [
        'checkboxes',
        'brand',
        'name',
        'amount',
        'hasCollectionPackaging',
        'ean',
        'priced',
      ],
      (filter, store: Store) =>
        store.dispatch(ProductSortimentActions.loadProductSortiment.trigger()),
      (filter, store: Store) =>
        store.dispatch(
          ProductSortimentActions.updateFilter.trigger({ filter })
        ),
      (store: Store) =>
        store.select(ProductSortimentSelectors.selectProductSortiment),
      (store: Store) =>
        store.select(ProductSortimentSelectors.selectProductSortimentLoading)
    );
  }

  public getCellTooltip(
    row: Record<string, string>,
    field: string
  ): string | null {
    switch (field) {
      case 'hasCollectionPackaging':
        return row['collectionPackagings']
          ? `${row['sumOfStandaloneUnits']} ${this.translateService.instant(
              `PACKAGING.PACKAGING.${row[
                'standalonePackingMethodSubType'
              ]?.toUpperCase()}`
            )}`
          : '';
      default:
        return null;
    }
  }

  checkboxLabel(id?: string): string {
    if (!id) {
      return `${
        this.productTableSource.isAllSelected() ? 'deselect' : 'select'
      } all`;
    } else return '';
  }

  addDiscount() {
    this.store.dispatch(
      VipDiscountsSellingActions.selectProducts.trigger({
        products: this.productTableSource.selection.selected,
      })
    );
    this.router.navigate(['/selling/prices/discounts/vip-discounts/settings']);
  }
}
